<span class="mc-router-link" (click)="navigate()">{{ label }}</span>
